import { useState, useEffect } from 'react'

import { Form, Field, FormElement } from '@progress/kendo-react-form'
import {
  FormDropDownListFilter,
  FormTextArea,
  FormDropDownList,
} from '../FormComponents'
import { requiredValidator } from '../Validators'
import { dropDown } from '../../../data/interfaces'
import { TabStrip, TabStripTab } from '@progress/kendo-react-layout'

import { getSitesDropdown } from '../../../data/siteData'
import { getPriorityDropdown } from '../../../data/priorityData'
import { getEnquirysourceDropdown } from '../../../data/enquirysourceData'
import { getEmployeeDropdown } from '../../../data/employeeData'
import { useNavigate } from 'react-router-dom'

const EnquiryAddFields = (props: any) => {
  const [siteData, setSiteData] = useState<dropDown[]>([])
  const [siteDataOrig, setSiteDataOrig] = useState<dropDown[]>([])
  const [employeeData, setEmployeeData] = useState<dropDown[]>([])
  const [employeeDataOrig, setEmployeeDataOrig] = useState<dropDown[]>([])
  const [priorityData, setPriorityData] = useState<dropDown[]>([])
  const [enquirysourceData, setEnquirysourceData] = useState<dropDown[]>([])
  const navigate = useNavigate()

  const addSiteHandler = () => {
    props.onAddSite()
  }

  useEffect(() => {
    const fetchSiteData = async () => {
      const siteData = await getSitesDropdown('')
      setSiteData(siteData)
      setSiteDataOrig(siteData)
    }

    fetchSiteData()
  }, [props.onSiteAddr])

  useEffect(() => {
    const fetchSiteData = async () => {
      const siteData = await getSitesDropdown('')
      setSiteData(siteData)
      setSiteDataOrig(siteData)
    }

    const fetchPriorityData = async () => {
      const priorityData = await getPriorityDropdown()
      setPriorityData(priorityData)
    }

    const fetchEnquirysourceData = async () => {
      const enquirysourceData = await getEnquirysourceDropdown()
      setEnquirysourceData(enquirysourceData)
    }

    const fetchEmployeeData = async () => {
      const employeeData = await getEmployeeDropdown('')
      setEmployeeData(employeeData)
      setEmployeeDataOrig(employeeData)
    }

    fetchEmployeeData()
    fetchSiteData()
    fetchPriorityData()
    fetchEnquirysourceData()
  }, [])

  //Search filters
  const searchSiteDropdown = (searchTerm: string) => {
    const fetchSiteData = async (search: string) => {
      await getSitesDropdown(search).then((result) => {
        setSiteData(result)
      })
    }

    fetchSiteData(searchTerm)
  }

  const searchEmployeeDropdown = (searchTerm: string) => {
    const fetchEmployeeData = async (search: string) => {
      await getEmployeeDropdown(search).then((result) => {
        setEmployeeData(result)
      })
    }

    fetchEmployeeData(searchTerm)
  }

  

  return (
    <TabStrip animation={false} selected={0} onSelect={() => {}} className='form__tabstrip__container'>
      <TabStripTab title='Enquiry Details'>
        <div style={{ display: 'flex', flexFlow: 'column', padding: '0.25rem 0 0 0' }}>
          <Form
            render={(formRenderProps) => (
              <FormElement style={{ width: '100%' }}>
                <fieldset className={'k-form-fieldset'}>

              <Field
                disabled={props.lockEdit}
                data={props.contactsForClient}
                originalData={siteDataOrig}
                name={'contact'}
                component={FormDropDownListFilter}
                label={'Contact:'}
                setData={props.setContactsForClient}
                onOpen={() => props.getAndStoreContactsForCustomer(props.clientId)}
                searchDropdown={searchSiteDropdown}
                defaultItem={props.contactsForClient.find((item: any) => Number(item.value) === Number(props.contact.value))}
                onChange={(e) => {
                  props.setContact({
                    ...e.value,
                    contactId: parseInt(e.value.value, 10),
                })
                  props.onUpdateEnquiryData('contactId', e.target.value.value)
                }}
              />

              <Field
                disabled={props.lockEdit}
                data={props.siteData}
                originalData={siteDataOrig}
                name={'siteAddr'}
                component={FormDropDownListFilter}
                label={'Address:'}
                setData={setSiteData}
                onOpen={() => props.getAndStoreAddressesForCustomer(props.clientId)}
                searchDropdown={searchSiteDropdown}
                defaultItem={props.siteData.find((item: any) => Number(item.value) === Number(props.siteAddr.value))}
                onChange={(e) => {
                  props.setSiteAddr({
                    ...e.value,
                    value: parseInt(e.value.value, 10),
                  })
                  props.onUpdateEnquiryData('siteId', e.target.value.value)
                }}
              />

              <Field
                name={'description'}
                component={FormTextArea}
                label={'Description: *'}
                placeholder={'Enter a description:'}
                validator={requiredValidator}
                onChange={(event) => {
                  props.onUpdateEnquiryData('description', event.target.value)
                }}
              />

              <Field
                data={employeeData}
                originalData={employeeDataOrig}
                name={'employeeAssignedToId'}
                component={FormDropDownListFilter}
                label={'Assigned to: *'}
                setData={setEmployeeData}
                placeholder={'Assign an employee:'}
                searchDropdown={searchEmployeeDropdown}
                validator={requiredValidator}
                onChange={(event) => {
                  props.onUpdateEnquiryData('employeeAssignedToId', event.target.value.value)
                }}
              />

              <Field
                data={enquirysourceData}
                name={'enquirysourceId'}
                component={FormDropDownList}
                label={'Enquiry source: *'}
                placeholder={'Choose enquiry source:'}
                validator={requiredValidator}
                onChange={(event) => {
                  props.onUpdateEnquiryData('enquirysourceId', event.target.value.value)
                }}
              />
            </fieldset>
              </FormElement>
            )}
          />

          <div style={{ marginTop: '0.5rem' }}>
            <div className='incoming__activity-cards'>
              <a href={`/enquiries?client=${props.client}`} target='_blank' rel='noreferrer'
                className='incoming__activity-card incoming__activity-card--enquiries'>
                <span className='incoming__activity-card__count'>{props.openEnquiries ?? 0}</span>
                <span className='incoming__activity-card__label'>Enquiries</span>
              </a>
              <a href={`/quotes?client=${props.client}`} target='_blank' rel='noreferrer'
                className='incoming__activity-card incoming__activity-card--quotes'>
                <span className='incoming__activity-card__count'>{props.openQuotes ?? 0}</span>
                <span className='incoming__activity-card__label'>Quotes</span>
              </a>
              <a href={`/jobs?client=${props.client}`} target='_blank' rel='noreferrer'
                className='incoming__activity-card incoming__activity-card--jobs'>
                <span className='incoming__activity-card__count'>{props.openJobs ?? 0}</span>
                <span className='incoming__activity-card__label'>Jobs</span>
              </a>
            </div>
            <button onClick={props.onSubmit} className='incoming__activity-submit'>
              {props.touchedClient ? 'Update Client & Create Enquiry' : 'Create Enquiry'}
            </button>
          </div>
        </div>
      </TabStripTab>
    </TabStrip>
  )
}

export default EnquiryAddFields
